// Copyright (c) 2016 Deere & Company

import './warranty-modal.scss';
import MediumModal from './moddal-lib/medium-modal';
import PropTypes from 'prop-types';
import React from 'react';

const WarrantyMediumModal = (props) => (
    <MediumModal
        {...props}
        className="warranty-medium-modal"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
    />
);

WarrantyMediumModal.displayName = 'WarrantyMediumModal';
WarrantyMediumModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
};

export default WarrantyMediumModal;
